import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { ParkbewilligungenData, PbKategorieActions } from '../parkbewilligungen-data';
import { UserData } from '../../../providers/user-data';

/**
 * Generated class for the PbactionsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pbkategorieactions',
  templateUrl: 'pbkategorieactions.html',
})
export class PbKategorieactionsPage  implements OnInit {
  public pbKategorieActions = PbKategorieActions;
  constructor(public navCtrl: NavController

            , public parkbewilligungenData: ParkbewilligungenData
            , private _viewController: ViewController
            , private userData: UserData
    ) 
  {

  }

  ionViewDidLoad() {
    
  }
  ngOnInit(){
    this.parkbewilligungenData.selectedKategorieAction = PbKategorieActions.None;
  }
  selectAction(action: PbKategorieActions){
    this.parkbewilligungenData.selectedKategorieAction = action;
    this._viewController.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/pbkategorieactions/pbkategorieactions.ts